import { Button } from '@equitymultiple/react-eui';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import { externalContactLink } from '../../utils/constants';
import { launchIntercom } from '../../utils/launchIntercom';
import * as styles from './Contact.module.scss';

interface Props {
  darkTheme?: boolean;
}

const Contact = ({ darkTheme }: Props) => {
  return (
    <div className={`${styles.contact} ${darkTheme ? styles.darkTheme : ''}`}>
      <div className="container">
        <h3 className="expressive heading4">Connect With Us</h3>
        <p className="body1">
          Our dedicated Investor Relations Team is standing by to help simplify
          your real estate investing process.
        </p>
        <StaticImage
          className={styles.irImage}
          src="../../assets/images/contact-team.png"
          alt="EquityMultiple team"
          placeholder="blurred"
        />
        <div className={styles.buttons}>
          <Button
            onClick={launchIntercom}
            variant={darkTheme ? 'white' : 'blue'}
          >
            Send a Message
          </Button>
          <Button
            target="_blank"
            href={externalContactLink}
            variant={darkTheme ? 'outlinedWhite' : 'outlined'}
          >
            Schedule a Call
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
